import React, { createElement } from 'react';
import { Tab } from '@alifd/next';
import Slider from './slider';
import { CbayelWorkflowDiagram as Diagram } from '@/components/workflow/workflow-diagram';
import { CbayelWorkflowAttachment as Attachment } from '@/components/workflow/workflow-attachment';
import './index.scss';
export const CbayelWorkflowTabContainer = (props) => {
    const { children, getFormValues, validateForms, ctx, __designMode, opinionProps, attachmentProps: attachmentSetterProps, diagramProps: diagramSetterProps, ...restProps } = props;
    const opinionFormProps = {
        getFormValues,
        validateForms,
        ctx,
        __designMode,
        ...opinionProps,
    };
    const diagramProps = {
        ctx,
        __designMode,
    };
    const attachmentProps = {
        ctx,
        __designMode,
    };
    const filterChildren = (children) => {
        return React.Children.map(children, (child) => {
            if (child?.type?.displayName === 'TabItem') {
                return child;
            }
            return null;
        });
    };
    return (createElement("div", { className: "workflow-tab-container" },
        createElement("div", { className: "tabs" },
            createElement(Tab, { ...restProps },
                filterChildren(children),
                attachmentSetterProps?.showAttachment && (createElement(Tab.Item, { title: "\u6D41\u7A0B\u9644\u4EF6" },
                    createElement(Attachment, { ...attachmentProps }))),
                diagramSetterProps?.showDiagram && (createElement(Tab.Item, { title: "\u6D41\u7A0B\u56FE" },
                    createElement(Diagram, { ...diagramProps }))))),
        createElement(Slider, { ...opinionFormProps })));
};
CbayelWorkflowTabContainer.Item = Tab.Item;
